import React from 'react';
import parse from 'html-react-parser';
import './style.sass';

const testHypotes = {
    desc: 'Перед стартом кампании подготовили объемную структуру рекламного кабинета:',
    list: [
        'собрали рекламные кампании на&nbsp;Поиске и&nbsp;в&nbsp;Сетях;',
        'подготовили рекламные кампании для поискового продвижения и&nbsp;в&nbsp;РСЯ по&nbsp;специализациям врачей и&nbsp;услуг медцентра;',
        'подготовили околотематические ключевые запросы по&nbsp;наиболее популярным заболеваниям, относящихся к&nbsp;специализации врача;',
        'проработали запросы по&nbsp;конкурентам;',
        'настроили ретаргетинг.',
    ],
};
const TestCaseBlock = () => {
    return (
        <div className="test-case">
            <div className="test-case__desc">{parse(testHypotes.desc)}</div>
            <ul className="test-case__ul">
                {testHypotes.list.map(item => {
                    return (
                        <li className="test-case__item" key={item}>
                            <span className="test-case__marker"></span>
                            <span className={'common__circle-info'}>{parse(item)}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
export default TestCaseBlock;
